import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { ISmartMeterSummary } from "./smartMeterSummary.types"
import { SmartMeterSummary } from "./smartMeterSummary"
import { GetSmartMetersSummaryQuery } from "@/api/hasura/generated/graphql"

export type SmartMeterSummaryRaw = GetSmartMetersSummaryQuery

export const SmartMeterSummaryParser: IParser<
  ISmartMeterSummary,
  SmartMeterSummaryRaw
> = {
  toDomain: (data: SmartMeterSummaryRaw): ISmartMeterSummary => {
    try {
      const statusCounts = data.smart_meter_dashboard_workstream_summary.reduce(
        (acc, { workstream, count }) => {
          if (workstream) {
            acc[workstream] = count
            acc.total += count
          }
          return acc
        },
        {
          working: 0,
          uncommissioned: 0,
          inherited: 0,
          inlifeissue: 0,
          criticalalert: 0,
          firmwareexpired: 0,
          total: 0,
        },
      )

      return new SmartMeterSummary(
        statusCounts.working,
        statusCounts.uncommissioned,
        statusCounts.inherited,
        statusCounts.inlifeissue,
        statusCounts.criticalalert,
        statusCounts.firmwareexpired,
        statusCounts.total,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
